import React, { FunctionComponent } from "react";
import { View, Text } from "@react-pdf/renderer";

import { DetailedCartItem } from "../../../../context/CartContext/CartContext.api.types";
import { displayMoney } from "../../../../utils/displayMoney";
import { ProductServices } from "../../../../services/products";

const isColoredVariation = (color: string) => {
  if (
    color === "plata" ||
    color === "rojo" ||
    color === "amarillo" ||
    color === "blanco" ||
    color === "soaked" ||
    color === "rose" ||
    color === "golden"
  )
    return true;
};

const getColorLabel = (color: string) => {
  console.log(color);
  switch (color) {
    case "amarillo":
      return "Oro Amarillo";
      break;
    case "rojo":
      return "Oro Rojo";
      break;
    case "blanco":
      return "Oro Blanco";
    case "plata":
      return "Plata";
    case "soaked":
      return "Empavonado";
    case "rose":
      return "Rosé";
    case "golden":  
      return "Dorado";
    default:
      return "";
      break;
  }
};

const DetailedItem: FunctionComponent<DetailedCartItem> = ({
  variation,
  quantity,
  weight,
  customization,
  product,
  manufacturingCost,
}) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline",
      fontSize: "8px",
      borderBottom: "0.505944px solid #B1B1B1",
      width: "100%",
      fontFamily: "Mont-Regular",
    }}
  >
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "7%",
        textAlign: "center",
        borderLeft: "0.505944px solid #B1B1B1",
      }}
    >
      {quantity}
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "13%",
        textAlign: "center",
      }}
    >
      {product.sku}
    </Text>
    <Text
      style={{
        width: "60%",
        display: "flex",
        flexDirection: "row",
        paddingBottom: "8px",
        paddingTop: "8px",
      }}
    >
      <Text> {product.title} |</Text>
      {isColoredVariation(variation.color) ? (
        <Text> {getColorLabel(variation.color)} |</Text>
      ) : null}
      <Text>
        {" "}
        {
          ProductServices.getProductsLabels(
            product.category ? product.category : "",
            product.department ? product.department : "",
            product.isCustom ? product.isCustom : false
          ).gaugeLabel
        }{" "}
        {variation.gauge} |
      </Text>
      <Text>
        {" "}
        {
          ProductServices.getProductsLabels(
            product.category ? product.category : "",
            product.department ? product.department : "",
            product.isCustom ? product.isCustom : false
          ).lenghtLabel
        }{" "}
        {variation.length} |
      </Text>
      <Text> {displayMoney(Number(manufacturingCost / quantity))} (u) </Text>
      <Text> = {variation.weight} gr</Text>
      {customization && (
        <Text
          style={{
            color: "gray",
          }}
        >
          {" "}
          | {customization}
        </Text>
      )}
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "10%",
        borderRight: "0.505944px solid #B1B1B1",
        textAlign: "center",
      }}
    >
      {Number(weight).toFixed(2)} gr{" "}
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "10%",
        textAlign: "center",
        borderRight: "0.505944px solid #B1B1B1",
      }}
    >
      {manufacturingCost == 0 ? "Consultar" : displayMoney(manufacturingCost)}
    </Text>
  </View>
);

export default DetailedItem;
